export const numberOfDependentsError = (value?: string): string | undefined =>
    !value?.trim() || (/^\d+$/.test(value.trim()) && Number(value) <= 2147483647)
        ? undefined
        : 'Enter a whole number of dependents';

export const parseNumberOfDependents = (value?: string): number | undefined => {
    const error = numberOfDependentsError(value);
    if (error) throw new Error(error);
    return value?.trim() ? Number(value) : undefined;
};
